// extracted by mini-css-extract-plugin
module.exports = {"slide":"_3WKXH"};